export default __webpack_public_path__ + "static/media/pagination-arrow-down.ac76e3d1.svg";